var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8107 5.36643C15.5837 5.13184 15.2755 5 14.9542 5C14.6328 5 14.3247 5.13184 14.0977 5.36643L8.52137 11.1168C8.04756 11.6054 8.04756 12.3946 8.52137 12.8832L14.0977 18.6336C14.5715 19.1221 15.3369 19.1221 15.8107 18.6336C16.2845 18.145 16.2845 17.3557 15.8107 16.8671L11.0969 11.9937L15.8107 7.13287C16.2845 6.64428 16.2723 5.84249 15.8107 5.36643Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.f0f09616.svg";
export { ForwardRef as ReactComponent };